export const SPEED_MODE = [0.5, 0.75, 1, 1.25, 1.75, 2];
